<template>
  <div class="tw:mb-6">
    <h3 class="tw:font-bold tw:mb-1">{{ $t('check_out_currency_selection') }}</h3>
    <CurrencySelector
      :isFullName="true"
      :isLanding="false"
      :isDefaultMethod="false"
      version="light"
      size="big"
      source="studio-plus-payment-page"
      currencySelectTestId="studio-plus-currency-selector"
    />
    <div class="tw:mt-2 tw:flex tw:items-start">
      <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-[18px] tw:w-[18px] tw:mr-1 tw:mt-[1px]" />
      <p class="tw:text-sm" v-html="$t('check_out_currency_info')" />
    </div>
  </div>
</template>
<script setup>
import CurrencySelector from '@/components/locale/CurrencySelector.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
</script>
